import { PageLocatorMap } from '../types/PageLocatorMap';

export const previewPinVerifyPage = {
  alert: {
    error: 'preview-pin-verify-page.alert.error',
    success: 'preview-pin-verify-page.alert.success',
  },
  footer: {
    root: 'preview-pin-verify-page.footer.root',
  },
  form: {
    h1: 'preview-pin-verify-page.form.heading1',
    h3: 'preview-pin-verify-page.form.heading3',
    pinInput: (position: number): string =>
      `preview-pin-verify-page.form.pin-input-${position}`,
    pinInputError: 'preview-pin-verify-page.form.pin-error',
    resendPinLink: 'preview-pin-verify-page.form.resend-pin-link',
    root: 'preview-pin-verify-page.form.root',
  },
} as const satisfies PageLocatorMap;
